import styled from 'styled-components'

export const WrapperContainer = styled.div`
  display: flex;
  flex-direction: column;
  /* gap: 72px; */

  max-width: 920px;

  margin: 0 auto;
  margin-top: 5rem;

  padding: 0 1.5rem;

  .loading-block {
    height: 500px;
  }

  @media only screen and (min-width: 800px) {
    padding: 0;

    .loading-block {
      height: 800px;
    }
  }
`

export const Content = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`

export const TextContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 1.5rem;

  h4 {
    font-weight: 500;
    font-size: 18px;
    text-align: center;
  }

  @media only screen and (min-width: 800px) {
    h4 {
      width: 50%;
      margin-top: 2.5rem;
    }
  }
`
